<template>
  <div>
    <button
      type="button"
      :class="['btn btn-checkbox btn-light mr-2', selected ? 'check' : '']"
      aria-haspopup="true"
      aria-expanded="false"
      @click="$emit('change')"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'EquipmentSelectionCheckbox',
  emits: ['change'],
  props: {
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>
